export default {
  buildQuery: function (params) {
    params = params || {}
    return Object.keys(params)
      .map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
      })
      .join('&')
  }
}



// WEBPACK FOOTER //
// ./src/common/services/url.js